<template>
  <div id="paper-index">
    <!-- 试卷管理 -->
    <div class="left">
      <div class="line">
        <div class="li"></div>
        试卷管理
      </div>
      <div
        :class="{ line: true, 'active-menu': menu.path == activeMenu }"
        v-for="(menu, index) in menu"
        :key="index"
        @click="gotoChilder(menu)"
      >
        {{ menu.text }}
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import * as base from "../js/base.js";
export default {
  data() {
    return {
      activeMenu: "",
      menu: base.getSubMenuListByFatherMenu("paper-index"),
    };
  },
  methods: {
    // 权限设置  获取系统设置界面所有子界面的权限  试卷设置 2
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "2" },
        });
        console.log(resultData);
        this.menu = base.returnAllButton(this.menu, resultData, "text");
      } catch (error) {}
    },
    /**
     * 路由跳转
     */
    gotoChilder(menu) {
      this.activeMenu = menu.path;
      sessionStorage.setItem("subMenu", menu.path);
      this.$router.push("/admin/paper-index/" + menu.path);
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    this.activeMenu = sessionStorage.getItem("subMenu");
    let falg = false;
    this.menu.forEach((element) => {
      if (this.activeMenu == element.path) {
        falg = true;
        this.gotoChilder(element);
        return;
      }
    });
    if (!falg && this.menu.length > 0) {
      this.activeMenu = this.menu[0].path;
      this.gotoChilder(this.menu[0]);
    }
  },
};
</script>

<style lang="less" scoped>
#paper-index {
  width: 100%;
  height: 100%;
  display: flex;
  > .left {
    width: 290px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    > .line {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      // justify-content: center;
      padding-left: 80px;
      // font-weight: 600;
      font-size: 15px;
      box-sizing: border-box;
      cursor: pointer;
      &:nth-child(1) {
        padding-left: 25px;
        font-weight: bold;
        font-size: 16px;
        height: 60px;
        cursor: default;
        border-bottom: 1px solid #e7e7e7;
      }
      > .li {
        width: 3px;
        height: 18px;
        background-color: @baseColor;
        margin-right: 8px;
        margin-top: 2px;
      }
    }
    > .active-menu {
      background-color: @baseColor;
      color: #fff;
    }
  }
  > .content {
    width: 0;
    height: 100%;
    flex: 1;
  }
}
</style>